import {LeftColumn} from "../Components/Column";
import Page from "./Page";

function NewsPage() {
    return (
        <Page title="News">
            <LeftColumn>
                <p>You are warmly invited to join us on Wednesday, April 10, at 5:30pm for a presentation of “<a
                    href="https://www.keene.edu/news/events/detail/18470/" className="news-link" target="_blank" rel="noreferrer">The
                    Light
                    Inside the Dark: Witnessing in Empathy at Auschwitz</a>” Details are below for in-person
                    attendance
                    as
                    well as live-streaming. A recording will be available at 1-2 weeks after the event, at <a
                        href="https://www.keene.edu/academics/cchgs/" className="news-link"
                        target="_blank" rel="noreferrer">https://www.keene.edu/academics/cchgs/</a></p>

                <p>Please note that the venue has been changed to Mason Library 240, within the Cohen Center for
                    Holocaust
                    and Genocide Studies on the campus of Keene State College.</p>

                <p>
                    <iframe id="video" src="https://www.youtube.com/embed/h0UNs7YCy4k" title="Two Conversations Exhibit Trailer" allowFullScreen/>
                </p>

                <p>July 8&#45;August 27, 2023: <a href="https://salmonfallsgallery.com/exhibits--events.html"
                                                  className="news-link" target="_blank" rel="noreferrer">"Two
                    Conversations,"</a> Salmon
                    Falls
                    Gallery, 1 Ashfield Street, Shelburne Falls, MA, Opening reception: July 8, 2-4pm, Works by
                    Sharon
                    Myers
                    and Erika Radich</p>

                <p>July 15&#45;August 27, 2023: <a href="https://mitchellgiddingsfinearts.com/current-exhibits/"
                                                   className="news-link" target="_blank" rel="noreferrer">INNER LANDSCAPES: Three
                    Views</a>,
                    Mitchell Giddings Fine Arts, 183 Main Street, Brattleboro, VT. Works by Maggie Cahoon, Jessie
                    Pollock,
                    and Erika Radich, Opening reception, July 15, 5-7, Artist Forum, August 6, 5-7.</p>

                <p><i>Brattleboro Reformer</i> article, Thursday, September 20, 2018: <a
                    href="https://www.reformer.com/stories/green-printmaking-featured-in-voices,550783"
                    className="news-link"
                    target="_blank" rel="noreferrer">Green Printmaking featured in 'Voices'</a></p>

                <p><a href="https://www.youtube.com/watch?v=-Nr3QDqZeKI" className="news-link" target="_blank" rel="noreferrer">Artist
                    talk</a>,
                    Mitchell Giddings Fine Art, August 25, 2018</p>

                <p>July 21, 2016: Recipient of Ewing Arts Award.</p>

                <p>
                    <iframe id="video" src="https://www.youtube.com/embed/2Ji9VgvPXXM" title="Ewing Arts Awards: Erika Radich" allowFullScreen/>
                </p>

                <p className="news-link"><a href="https://keenesentinel.nh.newsmemory.com/?special=Ewing+Awards"
                                            className="news-link" target="_blank" rel="noreferrer">Ruth &amp; James Ewing Art Award
                    brochure</a> 7/22/2016</p>
            </LeftColumn>
        </Page>
    );
}

export default NewsPage;